import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';
import Banner from '../../Images/Banner.png'

export default function Footer({ CitiePhone, locationsMain }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
            <div className="FooterTop">
                <h1>ALSO OF INTERESST:</h1>
                <a href="/airduct">Air Duct</a>
                <a href="/dryer">Dryer Vent</a>
                <a href="/chimney">Chimney & Fireplace Service</a>
                <a href="hvac">HVAC Heating and Air Conditioning</a>
                <a href="attic">Attic Insulation</a>
                <a href="roofing">Roofing</a>
            </div>
            <div className="FooterTopMidd">
                <img src={require(`../../ImagesLogos/logobanner.png`)} />
                <img src={require(`../../ImagesLogos/Logo1.png`)} />
            </div>
            <div className="FooterBottom">
                <div className="FooterBottomLeft">
                    <img src={require(`../../ImagesLogos/Logo2.png`)} />
                    <p>The term "allergens" as used on this website pertains exclusively to inanimate dust-mite matter, non-living matter, or allergens from non-living sources. AttiAir serves to remove these contaminants to provide a cleaner & healthier home.</p>
                    <p>Copyright © 2001- 2024 AttiAir LLC. All Rights Reserved. All AttiAir. Available Services, Pricing, Promotions, and Hours of Operation may vary by location.</p>
                    <h3>AttiAir LLC</h3>
                    <div className="FooterBottompri">
                        <a href="/privacy-policy">Privacy Policy</a>
                        <a href="/terms-and-conditions">Terms And Conditions</a>
                    </div>
                </div>
                <div className="FooterBottomRight">
                    <h1>CONNECT WITH US</h1>
                    <p>Phone: {CitiePhone}</p>
                    <p>info@attiair.com</p>
                    <p>www.attiair.com</p>
                </div>
            </div>
        </div>
    )
}
